import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=e0b40a0e&scoped=true&"
import script from "./InsuranceList.vue?vue&type=script&lang=js&"
export * from "./InsuranceList.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceList.vue?vue&type=style&index=0&id=e0b40a0e&prod&scoped=true&lang=css&"
import style1 from "./InsuranceList.vue?vue&type=style&index=1&id=e0b40a0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b40a0e",
  null
  
)

export default component.exports